<div class="astral-auth-shell">
  <main class="astral-auth-panel hogia-id-login-failure">
    <header class="astral-auth-header">
      <div class="astral-auth-branding">
        <img src="assets/icons/hogia_logo.svg" alt="Hogia" />
        <span class="astral-auth-branding__divider" aria-hidden="true"></span>
        <span class="astral-auth-branding__name">DinHyresvärd</span>
      </div>
    </header>

    <section class="astral-auth-content" aria-live="polite">
      <h1 class="astral-auth-title">{{ 'HOGIA_ID_LOGIN.FAILURE_TITLE' | translate }}</h1>
      <p>{{ 'HOGIA_ID_LOGIN.FAILURE_MESSAGE' | translate }}</p>
      <button type="button" class="hogia-id-login-failure__button" (click)="retryHogiaIdLogin()">
        {{ 'HOGIA_ID_LOGIN.RETRY_LOGIN' | translate }}
      </button>
    </section>
  </main>
</div>
